var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 7.286,
    y: 173.1,
    style: {
      fill: "#103B9B"
    },
    width: 497.43,
    height: 165.81
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M395.901,7.286H116.099C56.003,7.286,7.286,56.003,7.286,116.099v56.997h497.427v-56.997 C504.714,56.003,455.997,7.286,395.901,7.286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#ED1F34"
    },
    d: "M7.286,395.901c0,60.095,48.717,108.812,108.812,108.812h279.803 c60.095,0,108.812-48.717,108.812-108.812v-56.997H7.286V395.901z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M395.901,0H116.099C52.082,0,0,52.082,0,116.099v279.803C0,459.918,52.082,512,116.099,512h279.803 C459.918,512,512,459.918,512,395.901V116.099C512,52.082,459.918,0,395.901,0z M116.099,14.573h279.803 c55.981,0,101.526,45.544,101.526,101.526v49.71H14.573v-49.71C14.573,60.117,60.118,14.573,116.099,14.573z M395.901,497.427 H116.099c-55.981,0-101.526-45.544-101.526-101.526v-49.71h390.655c4.025,0,7.286-3.262,7.286-7.287 c0-4.024-3.262-7.286-7.286-7.286H14.573V180.382h482.854v151.236H438.39c-4.025,0-7.286,3.262-7.286,7.286 c0,4.024,3.262,7.287,7.286,7.287h59.037v49.71C497.427,451.883,451.882,497.427,395.901,497.427z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRu);
export default __webpack_public_path__ + "static/media/ru.0da51185ee4b7433cc701268a31f4a70.svg";
export { ForwardRef as ReactComponent };